export default __webpack_public_path__ + "static/media/group_stats_tabs.8c203149.png";